export const JOB_STATUSES = {
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED'
};

export const ZONE_SELECTION = [
  {id: '2', value: '2'},
  {id: '3', value: '3'},
  {id: '4', value: '4'},
  {id: '5', value: '5'},
  {id: '6', value: '6'},
  {id: '7', value: '7'},
  {id: '8', value: '8'},
  {id: '9', value: '9'},
  {id: '10', value: '10'},
  {id: '11', value: '11'},
  {id: '12', value: '12'}
];

export const DEFAULT_NUM_ZONES = '5';

export const MONTH_ORDER =[
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const LAYERS_TYPES = {
  CCI: 'cci',
  YIELD: 'yield'
} as const;

export const MAX_SELECTED_LAYERS = {
  [LAYERS_TYPES.CCI]: 20,
  [LAYERS_TYPES.YIELD]: 8
} as const;

export const NUM_PRODUCTIVITY_BINS = 5;
export const PRODUCTIVITY_BIN_ROUNDING_VALUE = 10;

export const ZONE_GENERATION_MODEL = {
  [LAYERS_TYPES.CCI]: 'CCI',
  [LAYERS_TYPES.YIELD]: 'YIELD'
} as const;

export const AUTOZONES_STATUS = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING'
} as const;

// Codes of crops allowed to be used to get data layers for zone generation
export const CROP_CODES_FOR_AVAILABLE_LAYERS = [
  'corn',
  'corn-silage',
  'soybeans'
] as const;
